import React, { useState } from 'react'
import useAxiosInstance from '../../../../Utilities/Hooks/useAxiosInstance'
import { DELIVERY_FEES_API } from '../../../../Utilities/APIs/APIs'
import Form from '../../../Partials/Layouts/Forms/Form'
import ShortTextInput from '../../../Partials/Layouts/Forms/FormInputs/ShortTextInput/ShortTextInput'
import SwitchInput from '../../../Partials/Layouts/Forms/FormInputs/SwitchInput/SwitchInput'
import FormSubmitButton from '../../../Partials/Layouts/Forms/FormSubmitButton/FormSubmitButton'

function CreateDeliveryFee({

    employee, setShowCreateForm, setShowModal, triggerFetch

}) {

   const [name, setName] = useState('')
   const [amount, setAmount] = useState(0)
   const [isApplicable, setIsApplicable] = useState(false)
  
    const axiosInstance = useAxiosInstance()

    async function handleSubmit(e) {
        e.preventDefault()
        const itemData = new FormData()

        itemData.append('name', name)
        itemData.append('amount', amount)
        itemData.append('isApplicable', isApplicable)
   
    

        const response = await axiosInstance.post(DELIVERY_FEES_API, itemData)

        if (response) {

            setShowCreateForm(false);
            setShowModal(false);
            triggerFetch()
        }

    }

    return (
        <Form onSubmit={handleSubmit} hasImage>
            <ShortTextInput
                label= "Name"
                placeholder='Enter name'
                value={name}
                setState={setName}

            />
            <ShortTextInput
                label= "amount"
                placeholder='Enter amount'
                value={amount}
                setState={setAmount}

            />

             <SwitchInput
                label={'Is Applicable'}
                toggleSwitch={() => setIsApplicable(prevState => !prevState)}
                checked={isApplicable}
            />

            <FormSubmitButton text='Create Delivery Fee' />
        </Form>
    )
}

export default CreateDeliveryFee